export default {
    TMSWeChat_GroupCheck: "ba569c8d-32be-4a62-b5ef-b27d2f9c256f",
    TMSWeChat_GroupExplain: "3073ba87-6389-4adb-8311-fd551152dc5d",
    TMSWeChat_QueryGroupExplain: "D69C80D1-B65B-4F3D-B302-6FB1828CE161",
    TMSWeChat_ComprehensiveReport: "BE415119-4A5F-4201-AE2C-8CC9B2B1A3C2",
    TMSWeChat_TouristStat: "1E217060-839D-411A-ADD0-6DD15DBB7F9E",
    TMSWeChat_PassengerFlowStat: "82C8734A-E46B-4FBC-90EA-EC53E5861303",
    TMSWeChat_DeliverOrdersOnBehalf: "D754D093-3647-4ABA-BC6A-F06DD3105CEE",
    TMSWeChat_TemporaryOrderCode: "612B2395-2858-4038-8BC4-1DEE2E9C8731",
    TMSWeChat_EnrollOrder: "B3F419D8-BCC2-4EAF-9184-7B12993A26ED"
}